import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,

      login: async (email, password, tenantId = null) => {
        set({ isLoading: true, error: null });
        try {
          const response = await fetch(`${API_URL}/auth/login`, {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              // Include tenant context in headers if provided
              ...(tenantId && { 'X-Tenant-Subdomain': tenantId })
            },
            body: JSON.stringify({ email, password }),
          });

          const data = await response.json();

          if (!response.ok) {
            // Check for tenant mismatch error with redirect info
            if (data.code === 'AUTHENTICATION_ERROR' && data.details?.code === 'TENANT_MISMATCH') {
              const correctTenant = data.details.correctTenant;
              const errorMessage = data.error || 'User not found in this organization';
              set({ 
                isLoading: false, 
                error: errorMessage
              });
              return { 
                success: false, 
                error: errorMessage,
                tenantMismatch: correctTenant ? { subdomain: correctTenant } : null
              };
            }
            throw new Error(data.error || 'Login failed');
          }

          set({
            user: data.user,
            token: data.token,
            isAuthenticated: true,
            isLoading: false,
          });

          return { success: true };
        } catch (error) {
          set({ isLoading: false, error: error.message });
          return { success: false, error: error.message };
        }
      },

      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          error: null,
        });
      },

      clearError: () => set({ error: null }),
    }),
    {
      name: 'classroomdragon-auth',
      partialize: (state) => ({ user: state.user, token: state.token, isAuthenticated: state.isAuthenticated }),
    }
  )
);
